var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { connect } from "react-redux";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import pick from "lodash/pick";
import uniqBy from "lodash/uniqBy";
import assign from "lodash/assign";
import { APP_STATE } from "../../store/store";
import { getBookManager } from "../../models/BookModel";
import { BLOCK, COURSE_DESCRIPTION, COURSE_META, COURSE_TITLE, TIMESPAN_DESCRIPTION, TIMESPAN_TITLE } from "../../classConstants";
import { getClassName } from "../../helpers";
import { getPriceId, getTimespanId } from "../BookingForm/booking-form.helpers";
import { getBookData, getBookDataPaginatedResponse } from "../../store/actions/response.actions";
import styled from "styled-components";
import i18next from "i18next";
import { getBookDataResponseManager, isBookDataUpdated } from "../../models/BookModel/helpers";
var CourseMetaWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (max-width: 767px) {\n        .ws-wizard &:not(.ws-event-step-course-meta) {\n            display: var(--ws-wizard-mobile-course-meta, none);\n        }\n    }\n"], ["\n    @media (max-width: 767px) {\n        .ws-wizard &:not(.ws-event-step-course-meta) {\n            display: var(--ws-wizard-mobile-course-meta, none);\n        }\n    }\n"])));
var H2 = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var courseMetaFactory = function () {
    var CourseMetaComponent = function (props) {
        var course = props.course, timespan = props.timespan, place = props.place, _a = props.showDescription, showDescription = _a === void 0 ? true : _a, _b = props.showTitle, showTitle = _b === void 0 ? true : _b;
        var t = useTranslation().t;
        var getTimespanTitle = function () {
            return React.createElement("span", { className: TIMESPAN_TITLE, key: "timespan-title" },
                " ",
                parse(timespan.title),
                " ");
        };
        var getCourseTitle = function () {
            return React.createElement("span", { className: COURSE_TITLE, key: "course-title" },
                " ",
                parse(course.title),
                " ");
        };
        // const getPlaceTitle = () => {
        //     return <span className="place-title" key="place-title"> { place.title } </span>;
        // }
        var getTitle = function () {
            if (!showTitle)
                return null;
            var title = [];
            // if (place.title) { title.push(getPlaceTitle()); }
            if (!timespan.title && course.title) {
                title.push(getCourseTitle());
            }
            if (timespan.title) {
                title.push(getTimespanTitle() || '');
            }
            if (!title.length && props.defaultTitle)
                title.push(t(props.defaultTitle));
            title = title.filter(Boolean);
            var titleArray = title.length ? title : [];
            return titleArray.length ? React.createElement(H2, { as: props.displayTitleAs }, titleArray) : null;
        };
        var getCourseDescription = function () {
            var _a;
            if (!((_a = course.description) === null || _a === void 0 ? void 0 : _a.trim()))
                return null;
            return React.createElement("div", { className: getClassName(BLOCK, COURSE_DESCRIPTION), key: "course-description" }, parse(course.description));
        };
        var getTimespanDescription = function () {
            var _a;
            if (!((_a = timespan.description) === null || _a === void 0 ? void 0 : _a.trim()))
                return null;
            return React.createElement("div", { className: getClassName(BLOCK, TIMESPAN_DESCRIPTION), key: "timespan-description" }, parse(timespan.description));
        };
        var getDescription = function () {
            if (!showDescription)
                return props.defaultDescription && typeof props.defaultDescription === "string" ? parse(props.defaultDescription) : (props.defaultDescription || null);
            var description = [];
            // description += place.description;
            description.push(getCourseDescription());
            description.push(getTimespanDescription());
            if (!description.length && props.defaultDescription)
                description.push(parse(props.defaultDescription));
            return description;
        };
        return React.createElement(CourseMetaWrap, { className: getClassName(COURSE_META, props.className) },
            getTitle(),
            getDescription());
    };
    var mapStateToProps = function (state, _a) {
        var _b, _c;
        var name = _a.name, formName = _a.formName, paginated = _a.paginated;
        var currentState = state.appReducer.currentState;
        var bookEntities = (_c = getBookDataResponseManager(paginated
            ? getBookDataPaginatedResponse(state.responseReducer)
            : (_b = (getBookData(state.responseReducer) && [getBookData(state.responseReducer)])) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.entities;
        var forms = state.formReducer.forms;
        return {
            bookEntities: bookEntities,
            hasServerFilters: state.courseReducer.hasServerFilters,
            form: currentState === APP_STATE.FORM ? forms[formName] || forms[name] : null,
            currentState: currentState
        };
    };
    var mergeProps = function (stateprops, dispatch, ownProps) {
        var _a;
        var _b;
        var bookEntities = stateprops.bookEntities, form = stateprops.form, currentState = stateprops.currentState, hasServerFilters = stateprops.hasServerFilters;
        var filterValues = ownProps.filterValues, otherOwnProps = __rest(ownProps, ["filterValues"]);
        var categoryNames = (form || {}).categoryNames;
        var bm = getBookManager(bookEntities);
        var useTimespanCategories = !!ownProps.timespanId;
        var isBookingForm = useTimespanCategories || currentState === APP_STATE.FORM;
        var coursefilterArray = useTimespanCategories ? [] : (isBookingForm ? categoryNames : filterValues === null || filterValues === void 0 ? void 0 : filterValues.courses) || [];
        // const timespanPlace = (bm.courseTimespans().findById(timespanId) as CourseTimespanModel)?.place() || null;
        var fixedCourses = hasServerFilters ? bm.courseTimespans().getFixedCourses().all() : [];
        var selectedCourses = bm.courses().filter(function (m) { return coursefilterArray.includes(m.get("name")); }).all();
        var filteredTimespans = bm.courseTimespans().applyUserFilters(filterValues);
        var timespanId = ownProps.timespanId || getTimespanId(form);
        var getTimespan = function () { var _a; return (_a = ownProps.courseTimespan) !== null && _a !== void 0 ? _a : bm.courseTimespans().findById(+timespanId); };
        var timespanCategories = isBookingForm
            ? ((_b = getTimespan()) === null || _b === void 0 ? void 0 : _b.courses()) || null
            : (filteredTimespans.getFixedCourses());
        var fixedValues = {
            courses: useTimespanCategories ? [] : uniqBy(fixedCourses.concat(selectedCourses), "id").filter(Boolean),
            timespans: (!isBookingForm ? [] : (timespanId
                ? [getTimespan()]
                : bm.courseTimespans().size === 1
                    ? [bm.courseTimespans().first()]
                    : []))
        };
        var fixedCourseIds = fixedValues.courses.map(function (m) { return m.id; });
        if (timespanCategories) {
            var filteredTimespanCategoriesArray = timespanCategories.filter(function (m) { return !fixedCourseIds.includes(m.id); }).all();
            (_a = fixedValues.courses).push.apply(_a, filteredTimespanCategoriesArray);
            fixedCourseIds = fixedValues.courses.map(function (m) { return m.id; });
        }
        // if (tiemspanId && timespanPlace) {
        //     fixedValues.places = [timespanPlace] as PlaceModel[];
        // }
        var meta = {
            // place: {
            //     title: fixedValues.places.map((m) => m.get("title")).join(" "),
            //     description: fixedValues.places.map((m) => m.get("presented.body")).join(" "),
            // },
            course: {
                title: fixedValues.courses.map(function (m, index) {
                    var title = m.get("title");
                    return i18next.t(ownProps.placement + ".course_format", {
                        title: title,
                        position: index + 1,
                        defaultValue: title,
                        id: m.get('name'),
                    }) || title;
                }).join(" "),
                description: fixedValues.courses.map(function (m) { return m.get("description"); }).join(" "),
            },
            timespan: {
                title: fixedValues.timespans.map(function (m) {
                    return m === null || m === void 0 ? void 0 : m.getAsTitle([], pick(ownProps, "hidePrice", "placement", "titleKey"), { priceId: getPriceId(form) });
                }).join(" ") || "",
                description: fixedValues.timespans.map(function (m) { return ((m === null || m === void 0 ? void 0 : m.get("presented.body")) || ""); }).join(" "),
            }
        };
        return assign({}, dispatch, otherOwnProps, meta);
    };
    return connect(mapStateToProps, null, mergeProps, isBookDataUpdated('bookEntities'))(CourseMetaComponent);
};
export var CourseMeta = courseMetaFactory();
var templateObject_1, templateObject_2;
